import { render, staticRenderFns } from "./adjust-placement-bid-strategy-form.vue?vue&type=template&id=1bc065f5&scoped=true&"
import script from "./adjust-placement-bid-strategy-form.vue?vue&type=script&lang=js&"
export * from "./adjust-placement-bid-strategy-form.vue?vue&type=script&lang=js&"
import style0 from "./adjust-placement-bid-strategy-form.vue?vue&type=style&index=0&id=1bc065f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc065f5",
  null
  
)

export default component.exports